class VehicleFront {
  constructor({
    vehicleId = null,
    remoteId = null,
    licensePlate = null,
    description = null,
    isPrivate = null,
    vehicleType = null,
    validFrom = null,
    validUntil = null,
    employeeId = null,
    vendorId = null,
    gpsNumber = null,
    forTerrain = null,
    numberOfDoors = null,
    model = null,
    productionYear = null,
    note = null,
    kilometerCount = null,
    chargeDate = null,
    weight = null,
    card = null,
    cardType = null,
    companyId = null,
    employee = {
      id: null,
      firstName: null,
      lastName: null,
      hiddenId: null,
      hiddenFirstName: null,
      hiddenLastName: null,
    },
    isnew = false,
  }) {
    this.vehicleId = vehicleId;
    this.remoteId = remoteId;
    this.licensePlate = licensePlate;
    this.description = description;
    this.isPrivate = isPrivate;
    this.vehicleType = vehicleType;
    this.validFrom = validFrom;
    this.validUntil = validUntil;
    this.vendorId = vendorId;
    this.employeeId = employeeId;
    this.gpsNumber = gpsNumber;
    this.forTerrain = forTerrain;
    this.numberOfDoors = numberOfDoors;
    this.model = model;
    this.productionYear = productionYear;
    this.note = note;
    this.kilometerCount = kilometerCount;
    this.chargeDate = chargeDate;
    this.weight = weight;
    this.card = card;
    this.cardType = cardType;
    this.companyId = companyId;
    this.employee = employee;
    this.isnew = isnew;
  }

  updateEmployee(employeeId, firstName, lastName) {
    this.employee = {
      id: employeeId,
      firstName: firstName,
      lastName: lastName,
      hiddenId: null,
      hiddenFirstName: null,
      hiddenLastName: null,
    };
  }
}

class VehicleBack {
  constructor({
    vehicleId = vehicleId,
    remoteId = remoteId,
    licensePlate = licensePlate,
    description = description,
    employeeId = employeeId,
    isPrivate = isPrivate,
    vehicleType = vehicleType,
    validFrom = validFrom,
    validUntil = validUntil,
    vendorId = vendorId,
    gpsNumber = gpsNumber,
    forTerrain = forTerrain,
    numberOfDoors = numberOfDoors,
    model = model,
    productionYear = productionYear,
    note = note,
    kilometerCount = kilometerCount,
    chargeDate = chargeDate,
    weight = weight,
    card = card,
    cardType = cardType,
    companyId = companyId,
    employee = {
      id: null,
      hiddenId: null,
    },
    isnew = isnew,
  }) {
    this.vehicleId = vehicleId;
    this.remoteId = remoteId;
    this.licensePlate = licensePlate;
    this.description = description;
    this.isPrivate = isPrivate ? true : false;
    this.vehicleType = vehicleType;
    this.validFrom = validFrom;
    this.validUntil = validUntil;
    this.vendorId = vendorId;
    this.employeeId = employee.id ? employee.id : employee.hiddenId;
    this.gpsNumber = gpsNumber;
    this.forTerrain = forTerrain;
    this.numberOfDoors = numberOfDoors;
    this.model = model;
    this.productionYear = productionYear;
    this.note = note;
    this.kilometerCount = kilometerCount;
    this.chargeDate = chargeDate;
    this.weight = weight;
    this.card = card;
    this.cardType = cardType;
    this.companyId = companyId;
  }
}

export { VehicleBack, VehicleFront };
